export { PageHOC } from "./page_hoc";
